import { render, staticRenderFns } from "./BalanceFormSection.vue?vue&type=template&id=1a9a6d64"
import script from "./BalanceFormSection.vue?vue&type=script&lang=js"
export * from "./BalanceFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports